"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

const Chip = props => {
  const {
    value,
    onDelete,
    className,
    style
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('chip', className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "chip__value"
  }, value), /*#__PURE__*/_react.default.createElement("span", {
    onClick: onDelete,
    className: "chip__delete-btn"
  }));
};

Chip.propTypes = {
  value: _propTypes.default.string.isRequired,
  onDelete: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: _propTypes.default.object
};
Chip.defaultProps = {
  className: '',
  style: {}
};
var _default = Chip;
exports.default = _default;